// extracted by mini-css-extract-plugin
export default {"mainInfo":"sXfXF","additionalInfo":"_7QklU","container":"ARAmg","skeleton-progress":"a9-FU"};